import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { getRuneBySlug, getAllSlugs, DEEP_DIVE_WIKI_SOURCES } from '../data/runes.fi.js';
import './RuneDeepDive.css';

const RuneDeepDive = () => {
  const { slug } = useParams();
  const rune = getRuneBySlug(slug);
  const slugs = getAllSlugs();
  const idx = slugs.indexOf(slug);
  const prevSlug = idx > 0 ? slugs[idx - 1] : null;
  const nextSlug = idx >= 0 && idx < slugs.length - 1 ? slugs[idx + 1] : null;

  if (!rune) {
    return (
      <div className="rune-deep-dive">
        <div className="container">
          <p className="rune-not-found">Riimua ei löydy.</p>
          <Link to="/courses/runes" className="btn btn-secondary">
            Takaisin Riimukurssille
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="rune-deep-dive">
      <div className="container">
        <div className="rune-deep-back">
          <Link to="/courses/runes">← Takaisin Riimukurssille</Link>
        </div>

        <article className="rune-deep-article card">
          <header className="rune-deep-header">
            <div className="rune-deep-image-wrap rune-image-zoom">
              <img
                src={rune.image}
                alt={rune.nameFi}
                className="rune-deep-image rune-image"
              />
            </div>
            <h1 className="rune-deep-name">{rune.nameFi}</h1>
            <p className="rune-deep-phonetic">{rune.phonetic}</p>
            <p className="rune-deep-core">{rune.coreFi}</p>
          </header>

          <section className="rune-deep-section">
            <h2>Historia & käyttö</h2>
            <p>{rune.historyUseFi}</p>
          </section>

          <section className="rune-deep-section">
            <h2>Mitä se peilaa</h2>
            <p>{rune.symbolismFi}</p>
          </section>

          <section className="rune-deep-section">
            <h2>Kun tämä toistuu elämässä…</h2>
            <ul className="rune-deep-bullets">
              {rune.whenItRepeatsFi &&
                rune.whenItRepeatsFi.map((line, i) => (
                  <li key={i}>{line}</li>
                ))}
            </ul>
          </section>

          <section className="rune-deep-section">
            <h2>Tulkinta-apu</h2>
            <p>{rune.interpretationHelpFi}</p>
          </section>

          <section className="rune-deep-section">
            <h2>Varjopuoli & harhat</h2>
            <ul className="rune-deep-bullets">
              {rune.shadowPitfallsFi &&
                rune.shadowPitfallsFi.map((line, i) => (
                  <li key={i}>{line}</li>
                ))}
            </ul>
          </section>

          <section className="rune-deep-section">
            <h2>Sanat, jotka jäävät</h2>
            <div className="rune-deep-keywords">
              {rune.keywordsFi &&
                rune.keywordsFi.map((k) => (
                  <span key={k} className="rune-deep-keyword-tag">
                    {k}
                  </span>
                ))}
            </div>
          </section>

          <section className="rune-deep-section">
            <h2>Päiväkirjakysymykset</h2>
            <ul className="rune-deep-prompts">
              {rune.journalPromptsFi &&
                rune.journalPromptsFi.map((prompt, i) => (
                  <li key={i}>{prompt}</li>
                ))}
            </ul>
          </section>

          <section className="rune-deep-section rune-deep-ritual">
            <h2>🕯️ Päivän pieni rituaali (1 min)</h2>
            <ol className="rune-deep-ritual-steps">
              {rune.miniRitualFi &&
                rune.miniRitualFi.map((step, i) => (
                  <li key={i}>{step}</li>
                ))}
            </ol>
          </section>

          <section className="rune-deep-section rune-deep-sources">
            <h2>Lisätietoa / Lähteet</h2>
            <ul className="rune-deep-sources-list">
              {(rune.sources || []).concat(DEEP_DIVE_WIKI_SOURCES).map((s) => (
                <li key={s.url}>
                  <a href={s.url} target="_blank" rel="noopener noreferrer" className="rune-deep-source-link">
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        </article>

        <nav className="rune-deep-nav">
          {prevSlug ? (
            <Link to={`/courses/runes/${prevSlug}`} className="rune-deep-prev">
              ← Edellinen
            </Link>
          ) : (
            <span className="rune-deep-prev-placeholder" />
          )}
          <Link to="/courses/runes" className="rune-deep-index">
            Kurssin etusivu
          </Link>
          {nextSlug ? (
            <Link to={`/courses/runes/${nextSlug}`} className="rune-deep-next">
              Seuraava →
            </Link>
          ) : (
            <span className="rune-deep-next-placeholder" />
          )}
        </nav>
      </div>
    </div>
  );
};

export default RuneDeepDive;
